module.exports = __webpack_public_path__ + "img/economic-impact.954f728f.png";